var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { each } from "lodash";
import { H3 } from "@irati/ui/src/Headings";
import { Para } from "@irati/ui/src/Labels";
import Button from "@irati/ui/src/Button";
import id from "@irati/utils/id";
import { FormattedMessage } from "@irati/utils/lang";
import tracking from "@irati-tracking/recognition/shared";
import Flex from "@irati/ui/src/Flex";
var CancelConfirm = /** @class */ (function (_super) {
    __extends(CancelConfirm, _super);
    function CancelConfirm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getPreviousLocation = function () {
            var previous = _this.props.previous;
            var step = null;
            each(previous, function (value, key) {
                if (value === true) {
                    step = key;
                }
            });
            return step;
        };
        _this.handleContinue = function () {
            tracking.cancelContinue();
            var selectScreen = _this.props.selectScreen;
            var step = _this.getPreviousLocation();
            selectScreen(step);
        };
        _this.handleQuit = function () {
            var onHide = _this.props.onHide;
            tracking.cancelConfirm();
            onHide();
        };
        return _this;
    }
    CancelConfirm.prototype.render = function () {
        return (React.createElement(Flex, { direction: "column" },
            React.createElement(H3, { tiny: true },
                React.createElement(FormattedMessage, { id: "recognition.popup.shared.cancelConfirm.header" })),
            React.createElement(Para, null,
                React.createElement(FormattedMessage, { id: "recognition.popup.shared.cancelConfirm.p1" })),
            React.createElement(Flex, { alignItems: "center", justifyContent: "flex-end" },
                React.createElement(Button, { tertiary: true, id: id("continue", this.props), onClick: this.handleContinue, marginRight: 2 },
                    React.createElement(FormattedMessage, { id: "recognition.popup.shared.cancelConfirm.continue" })),
                React.createElement(Button, { id: id("quit", this.props), primary: true, onClick: this.handleQuit },
                    React.createElement(FormattedMessage, { id: "recognition.popup.shared.cancelConfirm.quit" })))));
    };
    CancelConfirm.defaultProps = {
        previous: null,
        id: "createChallenge_cancelConfirm"
    };
    return CancelConfirm;
}(Component));
export default CancelConfirm;
